import {
  RECEIVED_NOTIFICATION,
  NEW_NOTIFICATIONS,
  LOAD_NEW_NOTIFICATIONS,
  SET_SHOW_NOTIFICATION_PERMISSION_MODAL,
  NOTIFICATION_TITLE,
  SET_SHOW_HUDDLE_NOTIFICATION,
  SET_SHOW_KICK_NOTIFICATION,
} from "./types";

function setShowNotificationPermissionModal(data) {
  return {
    type: SET_SHOW_NOTIFICATION_PERMISSION_MODAL,
    payload: data,
  };
}

function setNotificationTitle(data) {
  return { type: NOTIFICATION_TITLE, payload: data };
}

function receivedNotification(data) {
  return { type: RECEIVED_NOTIFICATION, payload: data };
}

function newNotifications(data) {
  return { type: NEW_NOTIFICATIONS, payload: data };
}

function loadNewNotifications(data) {
  return { type: LOAD_NEW_NOTIFICATIONS, payload: data };
}

function setShowHuddleNotification(data) {
  return { type: SET_SHOW_HUDDLE_NOTIFICATION, payload: data };
}

function setShowKickNotification(data) {
  return { type: SET_SHOW_KICK_NOTIFICATION, payload: data };
}

const Actions = {
  setShowNotificationPermissionModal,
  receivedNotification,
  newNotifications,
  loadNewNotifications,
  setNotificationTitle,
  setShowHuddleNotification,
  setShowKickNotification,
};

export default Actions;
